import { createNotify, NotifyTypeDanger } from 'helpers/createNotify';

export const notifyFailed = (message: string | React.ReactNode | React.FunctionComponent): void => {
  createNotify(message, NotifyTypeDanger);
};
